import { useEffect } from 'react';
import useFocusTrap from '../../hooks/useFocusTrap';

export default function FocusTrap(props: any) {
  const elRef = useFocusTrap();

  useEffect(() => {
    if (!elRef.current) return;
    elRef.current.focus({ preventScroll: true });
  }, []);

  return (
    <div ref={elRef} tabIndex={0}>
      {props.children}
    </div>
  );
}
